<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title>
      <v-row>
        <v-col>
          <span class="headline">Dealer Salesperson Pending Payouts</span>
        </v-col>
        <v-col class="text-right">
          <v-btn small color="primary" :to="{ name: 'dealerSalespersonsPayouts' }">View All</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <span v-if="selectedFiscalYear && selectedFiscalYear.fiscalYearStart && selectedFiscalYear.fiscalYearEnd">
        <b>
          ({{ selectedFiscalYear.fiscalYearStart | formatDateClient("MM/DD/YYYY", selectedClient) }} -
          {{ selectedFiscalYear.fiscalYearEnd | formatDateClient("MM/DD/YYYY", selectedClient) }})
        </b>
        <br />
      </span>
      Pending payouts by salesperson.
      <br />
      Currently displaying only salespersons with payouts.
    </v-card-subtitle>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        dense
        :options.sync="options"
        :server-items-length="total"
        hide-default-footer
      >
        <template v-slot:item.participantFullName="{ item }">
          <a @click.prevent="viewSalespersonDetails(item.participantId)" href="#">
            {{ item.participantFirstName }} {{ item.participantLastName }}
          </a>
        </template>
        <template v-slot:item.missingRequiredInformation="{ item }">
          <v-icon v-if="!item.missingRequiredInformation" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
        <template v-slot:item.pendingAmount="{ item }">
          {{ (item.pendingAmount || 0) | toCurrency }}
        </template>
        <template v-slot:item.organizationName="{ item }">
          {{ item.organizationName }} ({{ item.organizationKey }})
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DealerSalespersonPendingWidget",
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      options: {
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true]
      },
      headers: [
        { text: "Salesperson Name", value: "participantFullName" },
        { text: "Dealer Name", value: "organizationName" },
        { text: "Pending", value: "pendingAmount" },
        {
          text: this.$i18n.translate("Profile Complete?"),
          value: "missingRequiredInformation",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient", "selectedFiscalYear"])
  },
  watch: {
    selectedFiscalYear() {
      this.fetchData();
    },
    selectedParticipant() {
      this.fetchData();
    },
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const organizationId = this.selectedParticipant?.organization?.id;
      const fiscalYear = this.selectedFiscalYear;

      if (!organizationId || !fiscalYear?.fiscalYearStart || !fiscalYear?.fiscalYearEnd) {
        this.items = [];
        this.total = 0;
        this.loading = false;
        return;
      }

      this.loading = true;

      let filters = {
        participantParentOrganization: { id: organizationId },
        payoutStatus: "pending"
      };

      filters.createdAfter = fiscalYear.fiscalYearStart;
      filters.createdBefore = this.$util
        .getDateInClientTimezone(fiscalYear.fiscalYearEnd)
        .add(1, "day")
        .toDate();

      const params = this.$util.buildPaginationParams(this.options);

      this.$api
        .post(`/api/payouts/search/group/byParticipant?${params.toString()}`, filters)
        .then(({ data }) => {
          this.items = data.content;
          this.total = data.totalElements;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewSalespersonDetails(salespersonId) {
      this.$router.push({ name: "salespersonDetails", query: { salespersonId } });
    }
  }
};
</script>
